import(/* webpackMode: "eager", webpackExports: ["Row","Col","Space","Avatar"] */ "__barrel_optimize__?names=Avatar,Col,Row,Space!=!/vercel/path0/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Space","Divider"] */ "__barrel_optimize__?names=Divider,Space!=!/vercel/path0/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/antd/lib/typography/Text.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/antd/lib/typography/Title.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/DisplaySlider/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/stylists/[id]/components/Appointment/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/stylists/[id]/components/DisplayBio/index.tsx");
